import React from "react";

const PrivacyPolicy = ({ getStyles, theme }) => {
  return (
    <div style={getStyles(theme).content}>
      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--primary)",
          color: "white",
          borderRadius: "8px",
          marginBottom: "20px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        IMPORTANT NOTICE
        <p style={{ marginTop: "10px", fontSize: "14px" }}>
          AI Craft Studios built Vape Formula Pro as an Ad Supported
          mathematical calculation tool. This service is provided at no cost and
          is intended for use as is. All calculations are performed locally on
          your device.
        </p>
      </div>

      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--sectionBackground)",
          borderRadius: "8px",
          marginBottom: "20px",
          border: "1px solid var(--primary)",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary)",
            marginBottom: "15px",
          }}
        >
          Limitations and Legal Requirements
        </h2>
        <ul style={{ marginBottom: "15px", paddingLeft: "20px" }}>
          <li>This app is not a medical device</li>
          <li>No medical claims or health advice are provided</li>
          <li>We do not promote or sell any substances</li>
          <li>No prescriptions or medical recommendations are given</li>
          <li>All calculations are for reference purposes only</li>
          <li>
            Users must comply with all applicable local laws and regulations
          </li>
        </ul>
      </div>

      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--sectionBackground)",
          borderRadius: "8px",
          marginBottom: "20px",
          border: "1px solid var(--primary)",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary)",
            marginBottom: "15px",
          }}
        >
          User Responsibility
        </h2>
        <p>Users acknowledge that:</p>
        <ul style={{ marginBottom: "15px", paddingLeft: "20px" }}>
          <li>This is a mathematical calculation tool only</li>
          <li>No medical decisions should be based on app calculations</li>
          <li>Professional medical advice should always be sought</li>
          <li>Users are responsible for compliance with local regulations</li>
        </ul>
      </div>

      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--sectionBackground)",
          borderRadius: "8px",
          marginBottom: "20px",
          border: "1px solid var(--primary)",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary)",
            marginBottom: "15px",
          }}
        >
          Educational Content Information
        </h2>
        <p>Our Vaping Educativo section:</p>
        <ul style={{ marginBottom: "15px", paddingLeft: "20px" }}>
          <li>Contains general informational content only</li>
          <li>Is not personalized medical advice</li>
          <li>Makes no health claims or recommendations</li>
          <li>Does not diagnose, treat, cure, or prevent any condition</li>
          <li>Is based on publicly available educational resources</li>
          <li>
            Should not be used as a substitute for professional medical advice
          </li>
        </ul>
      </div>

      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--sectionBackground)",
          borderRadius: "8px",
          marginBottom: "20px",
          border: "1px solid var(--primary)",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary)",
            marginBottom: "15px",
          }}
        >
          Data Usage and Storage
        </h2>
        <ul style={{ marginBottom: "15px", paddingLeft: "20px" }}>
          <li>All calculations are performed locally on your device</li>
          <li>No personal data is collected or transmitted</li>
          <li>Recipes and settings are stored only on your device</li>
          <li>No data synchronization with external servers</li>
          <li>You can delete all data by clearing app data or uninstalling</li>
        </ul>
      </div>

      <div
        style={{
          padding: "15px",
          backgroundColor: "var(--sectionBackground)",
          borderRadius: "8px",
          marginBottom: "20px",
          border: "1px solid var(--primary)",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
            color: "var(--primary)",
            marginBottom: "15px",
          }}
        >
          Advertising Policy
        </h2>
        <p>Regarding advertisements in our app:</p>
        <ul style={{ marginBottom: "15px", paddingLeft: "20px" }}>
          <li>Ads are provided by AdMob</li>
          <li>We do not share any user data with advertisers</li>
          <li>Ads are non-personalized</li>
          <li>No user tracking is performed by our app</li>
        </ul>
        <p>For AdMob's privacy practices, see their policy:</p>
        <div style={{ marginTop: "10px" }}>
          <a
            href="https://support.google.com/admob/answer/6128543"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--primary)" }}
          >
            AdMob Privacy Policy
          </a>
        </div>
      </div>

      <div
        style={{
          ...getStyles(theme).section,
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Third Party Services
        </h2>
        <p>Third party services used in this app:</p>
        <ul>
          <li>
            <a
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "var(--primary)" }}
            >
              Google Play Services
            </a>
          </li>
        </ul>
      </div>

      <div
        style={{
          ...getStyles(theme).section,
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Age Restriction
        </h2>
        <p>
          This app is intended for users 18 years or older. We do not knowingly
          collect or store information from anyone under 18 years of age.
        </p>
      </div>

      <div
        style={{
          ...getStyles(theme).section,
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Your Consent
        </h2>
        <p>
          By using the Application, you acknowledge and agree to these terms and
          conditions. You confirm that you understand this is a calculation tool
          only and accept all responsibilities described in this policy.
        </p>
      </div>

      <div
        style={{
          ...getStyles(theme).section,
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Updates to Privacy Policy
        </h2>
        <p>
          This privacy policy may be updated periodically. Users will be
          notified of any significant changes through app updates.
        </p>
        <p>Last updated: 2024-01-22</p>
      </div>

      <div
        style={{
          ...getStyles(theme).section,
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            ...getStyles(theme).subSectionTitle,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Contact Information
        </h2>
        <p>
          For questions about this privacy policy, contact: info@vapeformula.org
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;